import { Tag } from 'antd';
import { capitalize } from 'lodash';
import { linkCell } from 'utils/cell-formatter';
import { formatDateTime } from 'utils/formatDate';

const bankAccountStatusColors = {
  pending: 'orange',
  success: 'green',
  deleting: 'yellow',
  deleted: 'grey',
  failed: 'red',
};

// Bank accounts are only listed per user, so there is no User column.
export const columnsGenerator = ({ userId }: { userId?: string } = {}) => [
  {
    accessorKey: 'id',
    header: 'ID',
    cell: ({ getValue }) =>
      linkCell({ getValue, path: `/investment/users/${userId}/bank-accounts` }),
  },
  {
    accessorKey: 'status',
    header: 'Status',
    cell: ({ getValue }) => {
      const value = getValue();
      return value ? (
        <Tag color={bankAccountStatusColors[value] || 'default'}>
          {capitalize(value)}
        </Tag>
      ) : (
        '-'
      );
    },
  },
  {
    accessorKey: 'bank_name',
    header: 'Bank Name',
  },
  {
    accessorKey: 'bank_account_name',
    header: 'Bank Account Name',
  },
  {
    accessorKey: 'bank_account_number',
    header: 'Bank Account Number',
  },
  {
    accessorKey: 'account_number',
    header: 'Account Number',
  },
  {
    accessorKey: 'trading_account_manager',
    header: 'Trading Account Manager',
  },
  {
    accessorKey: 'created_at',
    header: 'Created At',
    cell: ({ getValue }) => formatDateTime(getValue()),
  },
];
